import type { I18n } from '@lingui/core'
import classNames from 'clsx'
import type { VFC } from 'react'

import Select from 'views/components/molecules/Select'
import { CONTACT_LENS_GROUP_ID } from 'views/containers/browser/ProductVariantsAttributesContainer/consts'

import type {
  InStockFields,
  ProductAttributes,
  Variant,
  VariantAttribute,
} from './../index'
import AttributePickerModalAndInfoButton from './AttributePickerModalAndInfoButton'

interface AttributePickerSelectAttributeProps {
  values: string[]
  isMasterPage: boolean
  selectedVariantAttributes: VariantAttribute[] | undefined
  variantAttribute: ProductAttributes
  isPersonal: boolean
  i18n: I18n
  inStockFields: InStockFields
  isSingleAttributeProduct: boolean
  upid?: string | boolean
  selectedVariant?: Variant
}
const AttributePickerSelectAttribute: VFC<
  AttributePickerSelectAttributeProps
> = ({
  values,
  selectedVariantAttributes,
  variantAttribute,
  isMasterPage,
  isPersonal,
  i18n,
  inStockFields,
  isSingleAttributeProduct,
  upid = '',
  selectedVariant,
}) => {
  const isContactLens = variantAttribute.groupId === CONTACT_LENS_GROUP_ID
  const isInStock = selectedVariant?.stockStatus.status === ''
  const checkIfInStock = (
    attributeValue: string,
    attributeCode: string,
    index: number
  ) => {
    if (attributeValue) {
      if (isSingleAttributeProduct) {
        return selectedVariant?.allAttributes[0]?.available[index]
      } else {
        return !!inStockFields[attributeCode]?.find(x => {
          return x === attributeValue
        })
      }
    }
  }

  const defaultValue = selectedVariantAttributes?.find(
    (selectedVariantAttribute: VariantAttribute) => {
      if (upid) {
        return variantAttribute.upids?.find(selectedUpid => {
          if (selectedUpid === upid) {
            selectedVariantAttribute.upids = [upid]
            return selectedVariantAttribute
          }
        })
      }
      if (selectedVariantAttribute.variantCode === variantAttribute.code) {
        return selectedVariantAttribute
      }
    }
  )
  const options = values.map((attributeValue: string, index: number) => ({
    value: isSingleAttributeProduct
      ? variantAttribute.upids[index]
      : attributeValue,
    text: attributeValue,
    disabled: false,
    isInStock:
      checkIfInStock(attributeValue, variantAttribute.code, index) ||
      isMasterPage,
    upid: isSingleAttributeProduct && variantAttribute.upids[index],
  }))

  options.unshift({
    value: '',
    text: i18n._('variantAttributes.select.pleaseSelect.label'),
    disabled: true,
    isInStock: false,
    upid: '',
  })
  const selectClasses = classNames('a-full-width', {
    'u-padding--right': isContactLens,
  })

  const selectedValue = () => {
    if (isMasterPage && isPersonal) {
      return options[0].value
    }
    if (upid && isSingleAttributeProduct) {
      return defaultValue?.upids[0]
    }
    return defaultValue?.value
  }

  return (
    <div className="l-flex" data-clientside-hook="variant-attibute-select">
      <Select
        className={selectClasses}
        id={variantAttribute.code}
        floatingLabel
        name={variantAttribute.label}
        label={variantAttribute.label}
        options={options}
        isSelectedGreyedOut={defaultValue && !isInStock}
        selectedValue={selectedValue()}
      />
      {isContactLens && (
        <AttributePickerModalAndInfoButton
          variantAttribute={variantAttribute}
          i18n={i18n}
        />
      )}
    </div>
  )
}
export default AttributePickerSelectAttribute
